import moment from 'moment';
import { Environments } from '../constants/System';

export const apiProtocol = (url) => {
  if ((url || '').includes('http://')) return 'http';
  if ((url || '').includes('https://')) return 'https';
  if ((url || '').includes('localhost')) return 'http';
  if ((url || '').includes('127.0.0.1')) return 'http';
  if ((url || '').includes('0.0.0.0')) return 'http';
  return 'https';
};

export const generateDateTimeRange = (selectedDate, selectedTimezone) => {
  const timezoneOffset = selectedTimezone.offset;

  // Convert to the selected timezone
  const startTimeString = `${selectedDate}T00:00:00Z`;
  const endTimeString = `${selectedDate}T23:59:59.999Z`;
  const startDateTime = moment(startTimeString, "YYYY-MM-DDTHH:mm:ssZ").subtract('hours', timezoneOffset).toISOString();
  const endDateTime = moment(endTimeString, "YYYY-MM-DDTHH:mm:ssZ").subtract('hours', timezoneOffset).toISOString();
  return {
    start: startDateTime,
    end: endDateTime,
  };
};

export const dateTimeRangeQueries = (dateFrom, dateTo, timezone) => {
  const sdt = generateDateTimeRange(dateFrom, timezone);
  const edt = generateDateTimeRange(dateTo, timezone);
  return `from=${sdt.start}&to=${edt.end}`;
};

export const dateAndTimeRangeQueriesArray = (dateFrom, dateTo, timezone) => {
  const sdt = generateDateTimeRange(dateFrom, timezone);
  const edt = generateDateTimeRange(dateTo, timezone);
  return [
    `from=${dateFrom}`,
    `to=${dateTo}`,
    `fromDateTime=${sdt.start}`,
    `toDateTime=${edt.end}`,
  ];
};

export const dateTimeRangeCondition = (dateFrom, dateTo, timezone, field = 'created_at') => {
  const sdt = generateDateTimeRange(dateFrom, timezone);
  const edt = generateDateTimeRange(dateTo, timezone);
  return `"${field}": {"$gte": "${sdt.start}", "$lte": "${edt.end}"}`;
};

export const apiBaseUrl = (endpoint) => {
  const protocol = apiProtocol(endpoint);
  return `${protocol}://${endpoint}`.trim();
};

export const toMonthName = (monthNumber) => {
  const date = new Date();
  date.setMonth(monthNumber - 1);
  return date.toLocaleString('en-US', { month: 'short' });
};

export const weeksInYear = (year) => Math.max(
  moment(new Date(year, 11, 31)).isoWeek(),
  moment(new Date(year, 11, 31 - 7)).isoWeek(),
);

export const getDateOfWeek = (w, y) => {
  const d = (1 + (w - 1) * 7); // 1st of Jan + 7 days for each week
  return new Date(y, 0, d);
};

export const getDateOfISOWeek = (w, y) => {
  const simple = new Date(y, 0, 1 + (w - 1) * 7);
  const dow = simple.getDay();
  const ISOWeekStart = simple;
  if (dow <= 4) ISOWeekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else ISOWeekStart.setDate(simple.getDate() + 8 - simple.getDay());

  return ISOWeekStart.getDate();
};

export const weeklyDescription = (week, month, year) => {
  const fromDay = getDateOfISOWeek(week, year);
  const from = `${toMonthName(month)}/${fromDay}`;

  const toDay = (getDateOfISOWeek(week + 1, year)) - 1;
  let toMonth = toMonthName(month);
  if (toDay < fromDay) {
    toMonth = toMonthName((month + 1 === 13) ? 1 : month + 1);
  }

  const to = `${toDay}/${toMonth}`;
  return `${from} → ${to}`;
};
